import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { User } from '@percent/partner-dashboard/context/auth/authContext/AuthContext.types'
import { Wizard } from './Wizard/Wizard'
import { SetupQRStepContainer } from './SetupQRStep/SetupQRStepContainer'
import { ConfirmationCodeStepContainer } from './ConfirmationCodeStep/ConfirmationCodeStepContainer'
import { SaveBackupCodeStep } from './SaveBackupCodeStep/SaveBackupCodeStep'
import { SetupComplete } from './SetupComplete/SetupComplete'
import { SET_AUTHORISED } from '@percent/partner-dashboard/context/auth/authReducer/authReducer'
import styles from './TwoFactorAuthenticationSetup.module.scss'
import { useAuthState } from '@percent/partner-dashboard/common/hooks/useAuthState/useAuthState'
import { useAuthDispatch } from '@percent/partner-dashboard/common/hooks/useAuthDispatch/useAuthDispatch'

export function TwoFactorAuthenticationSetup() {
  const { state } = useLocation()
  const { isAuthorised } = useAuthState()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useAuthDispatch()
  const [userData, setUserData] = useState<undefined | User>(undefined)

  const signInToApp = () => {
    localStorage.authState = JSON.stringify({
      isAuthorised: true,
      isAuthorising: false
    })

    dispatch({
      type: SET_AUTHORISED,
      payload: {
        user: userData
      }
    })
    navigate('/')
  }

  useEffect(() => {
    if (isAuthorised && !state?.otpData) {
      navigate('/')
    }
  }, [isAuthorised, navigate, state])

  const steps = [
    {
      title: t('2fa.firstStepTitle'),
      step: <SetupQRStepContainer />
    },
    {
      title: t('2fa.secondStepTitle'),
      step: <ConfirmationCodeStepContainer setUserData={setUserData} />
    },
    {
      title: t('2fa.thirdStepTitle'),
      step: <SaveBackupCodeStep otpCode={userData?.twoFaBackupCode} />
    }
  ]

  useEffect(() => {
    if (!state?.password && !state?.otpData) {
      navigate('/signin')
    }
  }, [state, navigate])

  return (
    <div className={styles.container}>
      <Wizard steps={steps}>
        <SetupComplete signInToApp={signInToApp} />
      </Wizard>
    </div>
  )
}
